// Assets
import logo from "@/assets/logos/planetrus-horizontal-logo.png";

// Icons
import { FaWhatsapp, FaLinkedin } from "react-icons/fa";
import { IoLogoWechat } from "react-icons/io5";
import { useState } from "react";

// images
import wechatQrcode from "@/assets/images/contact-us/planetrus-qrcode.jpg";

const Footer = () => {
  const [showWechatModal, setShowWechatModal] = useState(false);

  const handleClickContact = (type: string) => {
    if (type === "wechat") {
      setShowWechatModal(true);
      return;
    }

    const links = {
      whatsapp: "https://wa.me/85292774669",
      linkedin: "https://www.linkedin.com/company/planetrus",
    };
    window.open(links[type as keyof typeof links], "_blank");
  };

  return (
    <div className="flex min-h-[200px] w-full justify-center bg-[#F0F0F380] sm:h-[252px]">
      <main className="w-full max-w-[1440px] px-4 py-8 sm:px-6 md:px-8 lg:px-[120px] lg:pt-12">
        {/* Mobile Layout (Flex Column) */}
        <div className="flex flex-col items-center gap-6 lg:hidden">
          <figure className="w-[180px] cursor-pointer overflow-hidden sm:w-[200px]">
            <img src={logo} alt="horizontal-logo" className="w-full" />
          </figure>

          <div className="flex items-center gap-6">
            <FaWhatsapp
              className="h-5 w-5 cursor-pointer text-primary hover:text-primary/80 sm:h-6 sm:w-6"
              onClick={() => handleClickContact("whatsapp")}
            />
            <IoLogoWechat
              className="h-5 w-5 cursor-pointer text-primary hover:text-primary/80 sm:h-6 sm:w-6"
              onClick={() => handleClickContact("wechat")}
            />
            <FaLinkedin
              className="h-5 w-5 cursor-pointer text-primary hover:text-primary/80 sm:h-6 sm:w-6"
              onClick={() => handleClickContact("linkedin")}
            />
          </div>

          <p className="text-center text-sm font-normal leading-normal text-primary">
            COPYRIGHT @ 2024 Planetrus All rights reserved.
          </p>
        </div>

        {/* Desktop Layout */}
        <div className="hidden lg:block">
          <figure className="w-[244px] cursor-pointer overflow-hidden">
            <img src={logo} alt="horizontal-logo" className="w-full" />
          </figure>
          <section className="flex items-center justify-end">
            <div className="flex items-center gap-6">
              <FaWhatsapp
                className="h-6 w-6 cursor-pointer text-primary hover:text-primary/80"
                onClick={() => handleClickContact("whatsapp")}
              />
              <IoLogoWechat
                className="h-6 w-6 cursor-pointer text-primary hover:text-primary/80"
                onClick={() => handleClickContact("wechat")}
              />
              <FaLinkedin
                className="h-6 w-6 cursor-pointer text-primary hover:text-primary/80"
                onClick={() => handleClickContact("linkedin")}
              />
            </div>
          </section>
          <section className="mt-6 flex w-full items-center justify-end">
            <p className="text-sm font-normal leading-normal text-primary">
              COPYRIGHT @ 2024 Planetrus All rights reserved.
            </p>
          </section>
        </div>
      </main>

      {/* WeChat QR Code Modal */}
      {showWechatModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="relative rounded-lg bg-white p-4 md:p-4">
            <button
              className="absolute top-4 text-gray-500 hover:text-gray-700"
              style={{ insetInlineEnd: "1rem" }}
              onClick={() => setShowWechatModal(false)}
            >
              ✕
            </button>
            <div className="flex flex-col items-center gap-6">
              <img src={wechatQrcode} alt="WeChat QR Code" className="max-w-[300px] md:max-w-[400px]" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;
